var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"tile-swiper-v2",class:[
        'tile-swiper-v2-container',
        _vm.theme,
        _vm.langText,
        {
            PC: _vm.isPC
        }
    ],style:([_vm.cssVar])},[_c('div',{ref:"swiperRef",staticClass:"img-list"},[_c('div',{staticClass:"swiper-wrapper"},_vm._l((_vm.list),function(item,i){return _c('div',{key:i,staticClass:"swiper-slide"},[_c('img',{staticClass:"swiper-item",attrs:{"src":item.img,"alt":item.alt || ''}})])}),0)]),_vm._v(" "),_c('ul',{staticClass:"card-list"},_vm._l((_vm.list),function(item,index){return _c('li',{key:index,class:[
                'card-item',
                {
                    active: _vm.activeIndex === index
                }
            ],on:{"click":function($event){return _vm.slideTo(index)}}},[_c('div',{staticClass:"card-item__head"},[_c('p',{staticClass:"card-item__title",domProps:{"innerHTML":_vm._s(item.title)}}),_vm._v(" "),_c('Icon',{staticClass:"card-item__icon",attrs:{"active":_vm.activeIndex === index}})],1),_vm._v(" "),(_vm.activeIndex === index)?_c('CollapseTransition',[_c('p',{staticClass:"card-item__desc",domProps:{"innerHTML":_vm._s(item.desc)}})]):_vm._e()],1)}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }